<template>
    <modal custom-class="max-w-md" class="text-center" @closed="$emit('closed')" cancel-button-text="Close">
        <h3 v-text="$t('FREDDIES_AMERALLY_OPTOUT')"/>
    </modal>
</template>

<script>
import Modal from '@/components/structure/Modal';

export default {
    name: 'OptOutAmerallyModal',
    components: {
        Modal,
    },
};

</script>
